import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'

import { IStorageService } from '@/services/contracts/storage'
import { queryClient } from '@/providers/libs/query-client'

type DownloadProps = {
  storageService: IStorageService
}

export function useDownload({ storageService }: DownloadProps) {
  const { id } = useParams()

  const { mutateAsync, isPending, error, data } = useMutation({
    mutationFn: (filename: string) => storageService.downloadFile(filename),
    mutationKey: ['download'],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['list_institution', id] })
    },
  })

  const download = useCallback(
    async (filename: string) => mutateAsync(filename),
    [mutateAsync],
  )

  const [response, errorResponse] = data || [{ url: null }, null]

  return {
    url: response.url,
    download,
    errorDownload: error || errorResponse,
    isLoadingDownload: isPending,
  }
}
